import type { Theme } from "@mui/material";

export type ContextAlertSeverity = "success" | "info" | "error";

const paletteKeyBySeverity = {
    success: "success",
    info: "primary",
    error: "error",
} as const;

/** Bordered, tinted-background alert styling shared by version and approval banners. */
export function contextAlertSx(theme: Theme, severity: ContextAlertSeverity) {
    const paletteKey = paletteKeyBySeverity[severity];
    return {
        border: `1px solid ${theme.palette[paletteKey][200]}`,
        backgroundColor: theme.palette[paletteKey].light,
        color: theme.palette.gray[800],
    };
}

/** The accent color for a `contextAlertSx` alert's icon, which stays tinted while the text goes gray. */
export function contextAlertIconColor(severity: ContextAlertSeverity) {
    return `${paletteKeyBySeverity[severity]}.main`;
}
